module.exports = __webpack_public_path__ + "static/img/lianjie.6fbf9a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lianjie.png
// module id = fWVa
// module chunks = 1